module.exports = __webpack_public_path__ + "static/media/bg_2.ef2ee04a.jpg";